import React, { useContext, useState } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import FrontEndContext from "../../context/FrontEndContext";
import Page from "../../components/Page";
import LoginButton from "../../components/LoginButton";
import "./index.css";

const HEADER_NAME = "";

export default function Login() {
  const navigate = useNavigate();
  const { handleAuthentication } = useContext(FrontEndContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  function validateForm() {
    return email.length > 0 && password.length > 0;
  }

  async function handleSubmit(event: React.SyntheticEvent) {
    event.preventDefault();
    setIsLoading(true);

    try {
      const user = await Auth.signIn(email, password);
      handleAuthentication(user.getSignInUserSession());
      navigate("/");
    } catch (e) {
      handleAuthentication(null, e);
    }
  }

  const handleSetEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSetPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event.target.value);
  };

  return (
    <Page name={HEADER_NAME} hideAuthentication={true}>
      <div className="login">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Username</Form.Label>
            <Form.Control autoFocus type="text" value={email} onChange={handleSetEmail} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="password">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" value={password} onChange={handleSetPassword} />
          </Form.Group>
          <LoginButton size="lg" type="submit" isLoading={isLoading} disable={!validateForm()}>
            Login
          </LoginButton>
        </Form>
      </div>
    </Page>
  );
}
